import { render, staticRenderFns } from "./cabinet-fl44-notice-card.vue?vue&type=template&id=cdd1939e&scoped=true&"
import script from "./cabinet-fl44-notice-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-notice-card.vue?vue&type=style&index=0&id=cdd1939e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd1939e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd1939e')) {
      api.createRecord('cdd1939e', component.options)
    } else {
      api.reload('cdd1939e', component.options)
    }
    module.hot.accept("./cabinet-fl44-notice-card.vue?vue&type=template&id=cdd1939e&scoped=true&", function () {
      api.rerender('cdd1939e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/cabinet-fl44-notice-card.vue"
export default component.exports